/** @format */

import { observable, action, decorate } from 'mobx';
import Service from './service';
// import mockData from '../../../../dev-json/getContrastData';
//@ts-ignore
import { Animated, Platform, InteractionManager } from 'react-native';
//@ts-ignore
import { JDDevice, JDNativeSystem, JDNativeToast } from '@jdreact/jdreact-core-lib';
import {
  ITicket,
  IUrlParams,
  goodsItem,
  CategoryVoItem,
  IPriceTab,
  IPublicPraiseTab,
  IAttributeVo,
  AvailableCouponsItem,
  IRes,
} from './domain';
import { API_SUCCESS } from '../../utils/common';
import Steep from '../../utils/Steep';
const { getRpx } = JDDevice;
const dh = JDDevice.height - Steep.NAVIGATION_BAR_HEIGHT + Steep._getSteepBarHeight() - getRpx(360);

interface IStore {
  urlParam: IUrlParams;
  //入口商品sku 埋点使用
  entrySku: string;
  golbalSku: string;
  cateId: string;
  action: string;
  golbalSkuList: string[];
  shareVo: null | {
    //主标题
    masterText: string;
    //副标题
    viceText: string;
    //对比详情 >",
    bottomText: string;
    //分享icon
    iconUrl: string;
  };
  showCateList: boolean;
  cateHeight: any;
  cateOpacity: any;
  showTicketDialog: boolean;
  couponHeight: any;
  couponOpacity: any;
  SamePropsCheck: boolean;
  tabCtrlList: { text: string; checked: boolean }[];
  tabCtrlIndex: number;
  tabLeftArr: number[];
  contentList: any[];
  contrastGoodsList: [] | goodsItem[];
  arrowDirection: any;
  titleHeight: any;
  categoryList: CategoryVoItem[];
  Dataloaded: boolean;
  popup: { topTitleText: string; noSelectToast: string; upLimitToast: string; skuBaseInfos: goodsItem[] } | null;
  showPopup: boolean;
  skuBaseInfos: goodsItem[] | [];
  selectList: goodsItem[] | [];
  handleSelectList: string[];
  maxCompareCount: number;
  currCategory: string;
  priceTab: IPriceTab | null;
  //基本属性tab
  attributeTab:
    | {
        groupName: string;
        attributeVoList: IAttributeVo[];
      }[]
    | null;
  //商品口碑tab
  publicPraiseTab: IPublicPraiseTab | null;
  //商品图预览显示
  imageOpacity: any;
  showImageView: boolean;
  imageViewList: string[];
  //优惠券列表
  ticket: ITicket | null;
  ticketIndex: number;
  //是否登录
  isLogin: boolean;
  handleLoading: boolean;
  //是否只读
  isReadOnly: boolean;
  deleteLock: boolean;
  initUrlParam: (this: IStore, param: IUrlParams) => void;
  initCategory: (this: IStore) => void;
  fadeInImageView: (this: IStore, imageViewList: string[]) => void;
  fadeOutImageView: (this: IStore) => void;
  handleShowImageView: (this: IStore, imageViewList: string[]) => void;
  handleHideImageView: (this: IStore) => void;
  handleSelectGoods: (this: IStore, item: any, index: number) => void;
  handleSwitchTab: (this: IStore, index: number) => void;
  slideDownTicketDialog: (this: IStore) => void;
  slideUpTicketDialog: (this: IStore, promotion: ITicket, index: number) => void;
  handleShowTicketDialog: (this: IStore) => void;
  handleHideTicketDialog: (this: IStore) => void;
  handleHideSameProps: (this: IStore) => void;
  handleDeleteGoods: (this: IStore, index: number) => void;
  deleteCompelete: (this: IStore) => void;
  slideDownSelectCategory: (this: IStore) => void;
  slideUpSelectCategory: (this: IStore) => void;
  handleSelectCategoryShow: (this: IStore) => void;
  handleSelectCategoryHide: (this: IStore) => void;
  handleSwitchCategory: (this: IStore, category: { cateId: any }) => void;
  resetGlobal: (this: IStore) => void;
  addGoods: (this: IStore) => void;
  getDataBySku: (this: IStore) => void;
  initData: (this: IStore, res: IRes) => void;
  getDataReject: (this: IStore) => void;
  loginVaildate: (this: IStore, isLogin: boolean) => void;
  switchCate: (this: IStore, cateId: string) => void;
  handleLoadingHide: (this: IStore) => void;
  handleCloseSelect: (this: IStore) => void;
  getDataByCateId: (this: IStore, cateId?: string) => void;
  resetHandleList: (this: IStore) => void;
  setReadOnly: (this: IStore, isReadOnly: boolean) => void;
  //领券接口
  getCoupon: (this: IStore, c: AvailableCouponsItem, index: number) => void;
  getCouponLock: boolean;
  getCouponReject: (this: IStore) => void;
  updateCoupon: (this: IStore, index: number) => void;
  updatePriceTab: (this: IStore, res: IRes, index: number) => void;
  initTabLeft: (this: IStore, left: number, width: number) => void;
}
const storeData: IStore = {
  //sku
  golbalSku: '',
  entrySku: '',
  action: '4',
  cateId: '',
  urlParam: {
    skuId: '',
    cateId: '',
    action: '',
    client: '',
  },
  golbalSkuList: [],
  isReadOnly: false,
  //分享接口
  shareVo: null,
  //切品类列表
  showCateList: false,
  //切品类高度
  cateHeight: new Animated.Value(0),
  cateOpacity: new Animated.Value(0),
  //优惠券弹层
  showTicketDialog: false,
  //优惠券弹层高度
  couponHeight: new Animated.Value(0),
  couponOpacity: new Animated.Value(0),
  //是否选中相同属性
  SamePropsCheck: false,
  //对比参数tab
  tabCtrlList: [
    {
      text: '价格优惠',
      checked: true,
    },
    {
      text: '基本参数',
      checked: false,
    },
    {
      text: '商品口碑',
      checked: false,
    },
  ],
  tabCtrlIndex: 0,
  tabLeftArr: [],
  //缓存列表
  contentList: [true, false, false],
  contrastGoodsList: [],
  //品类标题
  arrowDirection: new Animated.Value(0),
  titleHeight: new Animated.Value(0),
  // 品类列表
  categoryList: [],
  //数据是否加载完
  Dataloaded: false,
  //选择商品弹窗
  popup: null,
  //显示选择商品弹窗
  showPopup: false,
  //选择对比商品列表
  skuBaseInfos: [],
  //
  selectList: [],
  handleSelectList: [],
  //最大商品数
  maxCompareCount: 3,
  //当前品类
  currCategory: '',
  //外观价格tab
  priceTab: null,
  //基本属性tab
  attributeTab: null,
  //商品口碑tab
  publicPraiseTab: null,
  //商品图预览显示
  imageOpacity: new Animated.Value(0),
  showImageView: false,
  imageViewList: [],
  //优惠券列表
  ticket: null,
  ticketIndex: 0,
  isLogin: false,
  handleLoading: false,
  loginVaildate: action(function loginVaildate(isLogin: boolean) {
    this.isLogin = isLogin;
  }),
  initUrlParam: action(function initUrlParam(
    this: IStore,
    param: { skuId: string; cateId: string; action: string; client: string }
  ) {
    //仅从app商详入口进入时存在entrySku 其它场景为从h5唤起 或从我的对比入口进入
    if (param.action == '1') {
      this.entrySku = param.skuId;
    }
    this.urlParam = param;
    this.cateId = param.cateId;
    this.action = param.action;
    this.golbalSku = param.skuId;
    this.golbalSkuList = param.skuId.split(';');
  }),
  setReadOnly: action(function setReadOnly(this: IStore, isReadOnly: boolean) {
    this.isReadOnly = isReadOnly;
  }),
  // 初始化品类选择
  initCategory: action(function initCategory(this: IStore) {
    let tmp = this.categoryList.slice();
    tmp.map((item: CategoryVoItem) => {
      if (item.cateId == this.cateId) {
        item.checked = true;
      } else {
        item.checked = false;
      }
      return item;
    });
    this.categoryList = tmp;
  }),
  //预览商品图显示隐藏
  fadeInImageView: action(function handleShowImageView(this: IStore, imageViewList: string[]) {
    this.handleShowImageView(imageViewList);
    Animated.timing(this.imageOpacity, {
      toValue: 1,
      duration: 120,
      useNativeDrive: true,
    }).start();
  }),
  fadeOutImageView: action(function handleShowImageView(this: IStore) {
    let _this = this;
    Animated.timing(this.imageOpacity, {
      toValue: 0,
      duration: 120,
      useNativeDrive: true,
    }).start(function (data: { finished: any }) {
      if (data.finished) {
        _this.handleHideImageView();
      }
    });
  }),
  handleShowImageView: action(function handleShowImageView(this: IStore, imageViewList: any) {
    this.imageViewList = imageViewList;
    this.showImageView = true;
  }),
  handleHideImageView: action(function handleHideImageView(this: IStore) {
    this.showImageView = false;
  }),
  //选择对比商品
  handleSelectGoods: action(function handleSelectGoods(this: IStore, item: goodsItem, index: number) {
    const tmp = this.skuBaseInfos.slice();
    //从第二个商品开始展示选择商品列表
    tmp[index + 1].checked = !item.checked;
    let handleList = this.handleSelectList.slice();
    // 将未选择的商品放入 handleSelectList 入参后端的添加接口
    if (tmp[index + 1].checked) {
      handleList = this.handleSelectList.filter((g: string) => g != item.skuId);
    } else {
      handleList.push(item.skuId);
    }
    this.skuBaseInfos = tmp;
    this.handleSelectList = [...new Set(handleList)];
  }),
  //对比参数tab切换
  handleSwitchTab: action(function handleSwitchTab(this: IStore, index: number) {
    this.tabCtrlIndex = index;
    this.tabCtrlList = this.tabCtrlList.map((tab: { text: string; checked: boolean }, idx: number) => {
      if (idx === index) {
        tab.checked = true;
      } else {
        tab.checked = false;
      }
      return tab;
    });
  }),
  //tableft集合
  initTabLeft: action(function initTabLeft(this: IStore, left: number, width: number) {
    let tmp = this.tabLeftArr.slice();
    //安卓ios 宽度不一样
    if (tmp.indexOf(left) == -1) {
      tmp.push(left + (width - getRpx(52)) / 2);
    }
    tmp.sort((x, y) => x - y);
    tmp = [...new Set(tmp)];
    this.tabLeftArr = tmp;
  }),
  //优惠券弹窗显示隐藏
  slideDownTicketDialog: action(function slideDownTicketDialog(this: IStore) {
    let _this = this;
    this.showTicketDialog = true;
    Animated.parallel([
      //高度变化
      Animated.timing(this.couponHeight, {
        toValue: 0,
        duration: 280,
        useNativeDrive: true,
      }),
      //透明度变化
      Animated.timing(this.couponOpacity, {
        toValue: 0,
        duration: 100,
        useNativeDrive: true,
      }),
      //调用start启动动画,start可以回调一个函数,从而实现动画循环
    ]).start(function (data: { finished: any }) {
      if (data.finished) {
        _this.handleHideTicketDialog();
      }
    });
  }),
  slideUpTicketDialog: action(function slideUpTicketDialog(this: IStore, promotion: ITicket, index: number) {
    this.ticket = promotion;
    this.ticketIndex = index;
    if (!this.ticket) {
      return false;
    }
    this.showTicketDialog = true;
    Animated.parallel([
      //高度变化
      Animated.timing(this.couponHeight, {
        toValue: JDNativeSystem.isIPhoneX ? getRpx(1320) : getRpx(1200),
        duration: 300,
        useNativeDrive: true,
      }),
      //透明度变化
      Animated.timing(this.couponOpacity, {
        toValue: 0.55,
        duration: 280,
        useNativeDrive: true,
      }),
      //调用start启动动画,start可以回调一个函数,从而实现动画循环
    ]).start();
  }),
  handleShowTicketDialog: action(function handleShowTicketDialog(this: IStore) {
    this.showTicketDialog = true;
  }),
  handleHideTicketDialog: action(function handleHideTicketDialog(this: IStore) {
    this.showTicketDialog = false;
  }),
  //隐藏相同属性
  handleHideSameProps: action(function handleHideSameProps(this: IStore) {
    //当商品数最多有一个时候 隐藏属性功能禁用
    if (this.contrastGoodsList.length < 2) return;
    const SamePropsCheck = this.SamePropsCheck;
    this.SamePropsCheck = !SamePropsCheck;
  }),
  deleteCompelete: action(function deleteCompelete(this: IStore) {
    this.deleteLock = false;
  }),
  deleteLock: false,
  //删除对比商品
  handleDeleteGoods: action(function handleDeleteGoods(this: IStore, index: number) {
    if (this.deleteLock) {
      return;
    }
    this.deleteLock = true;
    let tmp = this.golbalSkuList.slice();
    let item = tmp.splice(index, 1);
    Service.delSku({
      compareCid: this.cateId,
      compareSku: item.join(''),
    }).then(
      (res) => {
        if (res && res.code == API_SUCCESS) {
          this.initData(res);
        } else {
          JDNativeToast.show(res.msg);
        }
        this.deleteCompelete();
      },
      (e) => {
        this.getDataReject();
        this.deleteCompelete();
        console.log('e', e);
      }
    );
  }),
  //品类显隐
  slideDownSelectCategory: action(function slideDownSelectCategory(this: IStore) {
    let _this = this;
    if (this.categoryList.length == 0) {
      return;
    }
    if (this.showCateList) {
      Animated.parallel([
        //高度变化
        Animated.timing(this.cateHeight, {
          toValue: 0,
          duration: 280,
          useNativeDrive: true,
        }),
        //透明度变化
        Animated.timing(this.cateOpacity, {
          toValue: 0,
          duration: 280,
          useNativeDrive: true,
        }),
        Animated.timing(this.arrowDirection, {
          toValue: 0,
          duration: 280,
          useNativeDriver: true,
        }),
        Animated.timing(this.titleHeight, {
          toValue: 0,
          duration: 280,
          useNativeDrive: true,
        }),
        //调用start启动动画,start可以回调一个函数,从而实现动画循环
      ]).start(function (data: { finished: any }) {
        if (data.finished) {
          _this.handleSelectCategoryHide();
        }
      });
    } else {
      this.showCateList = true;
      Animated.parallel([
        //高度变化
        Animated.timing(this.cateHeight, {
          toValue: 344,
          duration: 280,
          useNativeDrive: true,
        }),
        //透明度变化
        Animated.timing(this.cateOpacity, {
          toValue: 0.75,
          duration: 280,
          useNativeDrive: true,
        }),
        Animated.timing(this.arrowDirection, {
          toValue: 1,
          duration: 280,
          useNativeDriver: true,
        }),
        Animated.timing(this.titleHeight, {
          toValue: 1,
          duration: 120,
          useNativeDrive: true,
        }),
        //调用start启动动画,start可以回调一个函数,从而实现动画循环
      ]).start();
    }
  }),
  slideUpSelectCategory: action(function slideUpSelectCategory(this: IStore) {
    let _this = this;
    Animated.parallel([
      //高度变化
      Animated.timing(this.cateHeight, {
        toValue: 0,
        duration: 280,
        useNativeDrive: true,
      }),
      //透明度变化
      Animated.timing(this.cateOpacity, {
        toValue: 0,
        duration: 280,
        useNativeDrive: true,
      }),
      Animated.timing(this.arrowDirection, {
        toValue: 0,
        duration: 280,
        useNativeDriver: true,
      }),
      Animated.timing(this.titleHeight, {
        toValue: 0,
        duration: 280,
        useNativeDrive: true,
      }),
      //调用start启动动画,start可以回调一个函数,从而实现动画循环
    ]).start(function (data: { finished: any }) {
      if (data.finished) {
        _this.handleSelectCategoryHide();
      }
    });
  }),
  handleSelectCategoryShow: action(function handleSelectCategoryShow(this: IStore) {
    this.showCateList = !this.showCateList;
  }),
  handleSelectCategoryHide: action(function handleSelectCategoryHide(this: IStore) {
    this.showCateList = false;
  }),
  handleCloseSelect: action(function handleCloseSelect() {
    this.action = '4';
    this.golbalSku = this.skuBaseInfos
      .slice(1)
      .map((g) => g.skuId)
      .join(';');
  }),
  handleSwitchCategory: action(function handleSwitchCategory(this: IStore, category: { cateId: any }) {
    let tmp = this.categoryList.slice();
    tmp.map((item: CategoryVoItem) => {
      if (item.cateId == category.cateId) {
        item.checked = true;
        this.currCategory = item.cateName;
      } else {
        item.checked = false;
      }
      return item;
    });
    this.categoryList = tmp;
    this.switchCate(category.cateId);
  }),
  //切换类目时 清空缓存的sku
  resetGlobal: action(function resetGlobal(this: IStore) {
    this.golbalSku = '';
    this.golbalSkuList = [];
  }),
  switchCate: action(function switchCate(this: IStore, cateId: string) {
    this.handleLoading = true;
    this.slideUpSelectCategory();

    Service.switchCate({
      compareCid: cateId,
    }).then(
      (res) => {
        this.resetGlobal();
        //是否显示弹层
        if (res && res.code == API_SUCCESS) {
          this.initData(res);
        } else {
          JDNativeToast.show(res.msg);
        }
        this.handleLoadingHide();
      },
      (e) => {
        this.handleLoadingHide();
        console.log('e', e);
      }
    );
  }),
  addGoods: action(function addGoods(this: IStore) {
    this.Dataloaded = false;
    let params: { action: string; compareSku: string; compareCid: string; delSkus?: string } = {
      action: '1',
      compareSku: this.golbalSku,
      compareCid: this.cateId,
    };
    if (this.handleSelectList.length != 0 && this.handleSelectList.length < this.maxCompareCount) {
      params.delSkus = this.handleSelectList.join(';');
      this.resetHandleList();
    }
    return Service.loadData(params).then(
      (res) => {
        //是否显示弹层
        if (res && res.code == API_SUCCESS) {
          this.initData(res);
        } else {
          JDNativeToast.show(res.msg);
        }
      },
      (e) => {
        this.getDataReject();
        console.log('e', e);
      }
    );
  }),
  resetHandleList: action(function resetHandleList(this: IStore) {
    this.handleSelectList = [];
  }),
  getDataByCateId: action(function switchCate(this: IStore, cateId?: string) {
    this.Dataloaded = false;
    Service.switchCate({
      compareCid: cateId ? cateId : this.cateId.toString(),
    }).then(
      (res) => {
        //是否显示弹层
        if (res && res.code == API_SUCCESS) {
          this.initData(res);
        } else {
          JDNativeToast.show(res.msg);
        }
      },
      (e) => {
        this.getDataReject();
        console.log('e', e);
      }
    );
  }),
  getDataBySku: action(function getData(this: IStore) {
    this.Dataloaded = false;

    let params = {
      querySkus: this.golbalSku,
      compareCid: this.cateId,
    };
    Service.loadData(params).then(
      (res) => {
        //是否显示弹层
        if (res && res.code == API_SUCCESS) {
          this.initData(res);
        } else {
          JDNativeToast.show(res.msg);
        }
      },
      (e) => {
        this.getDataReject();
        console.log('e', e);
      }
    );
  }),
  initData: action(function initData(this: IStore, res: IRes) {
    const data = res.data;
    //缓存回传的 类目id
    if (data.cateId) {
      this.cateId = data.cateId;
    }
    //选择商品
    if (data.popup) {
      this.showPopup = true;
      this.skuBaseInfos = transformPopup(data.popup.skuBaseInfos);
      // this.selectList = this.skuBaseInfos.slice(1);
      //将添加商品页的 除当前商品外的sku缓存到 handleSelectList 中
      this.handleSelectList = data.popup.skuBaseInfos.slice(1).map((g: goodsItem) => {
        return g.skuId;
      });
    } else {
      this.showPopup = false;
      this.handleSelectList = [];
      this.skuBaseInfos = [];
    }
    //切品类列表
    if (data.categoryVoList) {
      let cate = transformCateList(this.cateId, data.categoryVoList);
      this.categoryList = cate.cateList;
      this.currCategory = cate.cateName;
    } else {
      this.categoryList = [];
      this.currCategory = '';
    }
    //顶部商品 以skuList为准对数据进行处理
    if (data.topCommonVo && data.topCommonVo.skuList) {
      this.contrastGoodsList = transformTopCommonVo(data.topCommonVo);
      this.golbalSkuList = transformTopCommonVo(data.topCommonVo).map((g: any) => g.sku);
      this.golbalSku = this.golbalSkuList.join(';');
    } else {
      //存在从url上传递sku 的场景 此处不能 reset
      // this.golbalSku = '';
      // this.golbalSkuList = [];
      this.contrastGoodsList = [];
    }
    //最大商品数
    if (data.maxCompareCount) {
      this.maxCompareCount = data.maxCompareCount;
    }
    //外观价格tab
    if (data.priceTab) {
      this.priceTab = data.priceTab;
      if (
        data.priceTab.price &&
        data.priceTab.price.prices &&
        data.priceTab.price.prices.length > 0 &&
        data.priceTab.price.prices[this.ticketIndex]
      ) {
        this.ticket = data.priceTab.price.prices[this.ticketIndex].promotion;
      }
    } else {
      this.priceTab = null;
    }
    //基本属性tab
    if (data.attributeTab) {
      this.attributeTab = data.attributeTab.attributeGroupVoList;
    } else {
      this.attributeTab = [];
    }
    //商品口碑tab
    if (data.publicPraiseTab) {
      this.publicPraiseTab = data.publicPraiseTab;
    } else {
      this.publicPraiseTab = null;
    }
    //分享
    if (data.shareVo) {
      this.shareVo = data.shareVo;
    }
    this.Dataloaded = true;
  }),
  handleLoadingHide: action(function handleLoadingHide() {
    //不包括导航loading
    this.handleLoading = false;
  }),
  getDataReject: action(function getDataReject() {
    //整体页面loading
    this.Dataloaded = true;
  }),
  getCouponLock: false,
  getCoupon: action(function getCoupon(this: IStore, coupon: AvailableCouponsItem, index: number) {
    if (this.getCouponLock) {
      return;
    }
    this.getCouponLock = true;
    Service.getCoupon({ roleId: coupon.roleId, couponKey: coupon.encryptedKey, sku: coupon.sku }).then(
      (res) => {
        //是否显示弹层
        if (res && res.code == API_SUCCESS) {
          JDNativeToast.show(res.result.desc, JDNativeToast.SHORT, JDNativeToast.SUCCESS);
          setTimeout(() => {
            this.updateCoupon(index);
          }, 300);
        } else {
          JDNativeToast.show(res.result.desc, JDNativeToast.SHORT, JDNativeToast.FAIL);
        }
        this.getCouponReject();
      },
      (e) => {
        this.getCouponReject();
        console.log('e', e);
      }
    );
  }),
  updateCoupon: action(function updateCoupon(index: number) {
    let params = {
      action: '3',
      compareCid: this.cateId,
    };
    Service.loadData(params).then(
      (res) => {
        //是否显示弹层
        if (res && res.code == API_SUCCESS) {
          this.initData(res);
        } else {
          JDNativeToast.show(res.msg, JDNativeToast.SHORT, JDNativeToast.FAIL);
        }
      },
      (e) => {
        console.log('e', e);
      }
    );
  }),
  updatePriceTab: action(function updatePriceTab(this: IStore, res: IRes, index: number) {
    const data = res.data;
    //外观价格tab
    if (data.priceTab) {
      this.ticket = data.priceTab.price.prices[this.ticketIndex].promotion;
    } else {
      this.ticket = null;
    }
  }),
  getCouponReject: action(function getCouponReject() {
    this.getCouponLock = false;
  }),
};
const store = observable(storeData);
function transformCateList(cateId: string, data: { cateId: string; cateName: string; checked?: boolean }[]) {
  if (!data) {
    return { cateList: [], cateName: '' };
  }
  let cateName = '';
  let cateList = data.map((cate) => {
    if (cate.cateId == cateId) {
      cate.checked = true;
      cateName = cate.cateName;
    } else {
      cate.checked = false;
    }
    return cate;
  });
  return { cateList, cateName };
}
function transformTopCommonVo(data: {
  skuList: any;
  picUrlList: any;
  picCountList: any;
  skuNameList: any;
  statusList: any;
}) {
  if (!data) {
    return [];
  }
  let skuList = data.skuList;

  let newData = skuList.map((sku: any, index: string | number) => {
    return {
      sku: sku,
      goodsName: data.skuNameList[index],
      goodsImg: data.picUrlList[index],
      goodsImgCount: data.picCountList[index],
      goodsState: data.statusList[index],
    };
  });

  return newData;
}
function transformPopup(data: any[]) {
  let tmp = data.map((goods: goodsItem, index: any) => {
    let tmpGoods = goods;
    tmpGoods.disabled = goods.soldOutFlag;
    tmpGoods.checked = false;

    return tmpGoods;
  });

  return tmp;
}
function tranfromDeliverInfos(data: any) {
  let publicPraiseTab = Object.assign({}, data);
  let tmpInfo = publicPraiseTab.deliverInfos.slice();
  let tmpDate = publicPraiseTab.promiseIconInfoVoList.slice();

  let tmpDeliverInfos = tmpInfo.map((info: any, index: string | number) => {
    return {
      logText: info,
      sendedText: tmpDate[index],
    };
  });
  publicPraiseTab.deliverInfos = tmpDeliverInfos;

  return publicPraiseTab;
}
export default store;
